<template>
  <section>
    <h5 class="text-gray-800 fw-bold mb-3">Обращение</h5>
    <div class="podft-list p-4 rounded border">
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">
          ИД
          <span class="text-gray-800 float-end" v-html="item.id"></span>
        </div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">
          Инициатор
          <span class="text-gray-800 float-end" v-html="item.changed"></span>
        </div>
      </div>
      <div v-if="item.checked" class="podft-list__item">
        <div class="text-gray-600 fs-7">
          Принял решение
          <span class="text-gray-800 float-end" v-html="item.checked"></span>
        </div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">
          Дата обращения <span class="text-gray-800 float-end">{{item.created}} | <b>{{item.created_time}}</b></span>
        </div>
      </div>
      <div v-if="item.checked" class="podft-list__item">
        <div class="text-gray-600 fs-7">
          Дата решения
          <span class="text-gray-800 float-end">{{item.updated}} | <b>{{item.updated_time}}</b></span>
        </div>
      </div>
      <div v-if="item.politician !== null" class="podft-list__item">
        <div class="text-gray-600 fs-7">
          ИПДЛ
          <span class="text-gray-800 float-end"><span class="badge badge-secondary">{{item.politician ? 'Да' : 'Нет'}}</span></span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'PodftAsideModalAppeal',
    props: {
      item: null
    },
    methods: { }
  }
</script>

<style scoped>

</style>